<!-- Issue Detail Page -->
<div class="issue-detail-container">
  <div *ngIf="issue">

    <!-- Parent div to hold both text and image -->
    <div class="issue-main-content">

      <!-- Issue Content Section -->
      <div class="issue-content">
        <h1>{{ issue.title }}</h1>

        <div
          class="description"
          [innerHTML]="issue.description">
        </div>
      </div>

      <!-- Issue Image Section -->
      <div
        *ngIf="issue.image"
        class="issue-image"
      >
        <img
          [src]="issue.image"
          [alt]="issue.title + ' image'"
          loading="lazy"
        />

        <div
          class="image-attribution"
          *ngIf="issue.attributionText && issue.attributionLink"
        >
          <a
            [href]="issue.attributionLink"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ issue.attributionText }}
          </a>
        </div>
      </div>

    </div>

    <!-- Living Document Disclaimer -->
    <p class="policy-disclaimer">
      Policies on this page are living documents. Lydia updates them as
      research, legislation, and community input evolve. If something here
      should be sharper, more accurate, or missing entirely,
      <a routerLink="/contact">tell her campaign</a>.
    </p>

    <!-- Related Issues -->
    <section
      class="related-issues"
      *ngIf="relatedIssues.length > 0"
      aria-labelledby="related-issues-heading"
    >
      <h2 id="related-issues-heading">
        Related Issues
      </h2>

      <div class="related-issues__grid">

        <a
          *ngFor="let relatedIssue of relatedIssues"
          class="related-issue-card"
          [routerLink]="['/issues', relatedIssue.slug]"
        >

          <div
            class="related-issue-card__image"
            *ngIf="relatedIssue.image"
          >
            <img
              [src]="relatedIssue.image"
              [alt]="relatedIssue.title + ' illustration'"
              loading="lazy"
            />
          </div>

          <div class="related-issue-card__body">

            <h3>
              {{ relatedIssue.title }}
            </h3>

            <p *ngIf="relatedIssue.summary">
              {{ relatedIssue.summary }}
            </p>

            <span>
              Read More
            </span>

          </div>

        </a>

      </div>
    </section>

    <!-- Social Share -->
    <app-social-share></app-social-share>

    <!-- Links for Navigation -->
    <div class="navigation-links">

      <a
        routerLink="/"
        class="back-btn"
      >
        Back to Home
      </a>

      <a
        routerLink="/issues"
        class="back-btn"
      >
        See All Issues
      </a>

    </div>

  </div>

  <!-- Loading Message -->
  <ng-template #loading>
    <p class="loading-message">
      Loading issue details...
    </p>
  </ng-template>
</div>
